import React from 'react';
import Modal from '@/common/components/Modal/index';
import Button from '@mui/material/Button';
import styles from '@/common/containers/Modals/ModulesDoneModal/styles.less';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const ModulesDoneModal = ({ onClose, ...props }) => {
  const { t } = useTranslation();
  const copyrightSup = <CopyrightSup />;
  return (
    <Modal className={styles.modal} {...props} overlay>
      <h4>
        <Trans
          i18nKey="Congratulations! You have completed the PAEM<copyrightSup/> requirements."
          components={{ copyrightSup }}
        />
      </h4>
      <p style={{ marginBottom: '6px' }}>
        {t(
          'Now that you have completed the Closing tasks, you have finished the process of managing the estate.'
        )}
      </p>
      <p>
        {t(
          'You can still review any of the tasks, but it is recommended to not make any changes to them as that could potentially modify their status.'
        )}
      </p>
      <div className={styles.btns}>
        <Button variant="contained" type="success" onClick={onClose}>
          {t('Ok')}
        </Button>
      </div>
    </Modal>
  );
};

export default ModulesDoneModal;
